// extracted by extract-css-chunks-webpack-plugin
module.exports = {"next":"next___j8btf","prev":"prev___B8S_m","arrow":"arrow___N9U4N"};